import { X } from '@/components/icons';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog';
import { useNavigate } from '@tanstack/react-router';

interface AllSetDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AllSetDialog({
  isOpen,
  onClose,
}: AllSetDialogProps) {
  const navigate = useNavigate();

  const handleCreateTrip = () => {
    onClose();
    navigate({ to: '/operations/trips', search: { createTrip: true } });
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="bg-surface-L0 rounded-lg border border-border-L2 shadow-lg p-8 max-w-[300px] gap-2">

        {/* Content */}
        <div className="flex flex-col items-start gap-4">
          <p className="text-lg font-bold text-content-primary-bold text-center tracking-[-1px] w-full leading-7">
            Your operation is ready
          </p>
          <p className="text-sm text-content-primary-subtle text-center w-full leading-5">
            You can now create trips and assign crew.
          </p>
          <Button
            onClick={handleCreateTrip}
            variant="primary"
            className="w-full bg-background-brand-bold text-background"
          >
            Create Trip
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
